import { IComponentOptions } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { GtmhubController } from "@gtmhub/core";
import { localize } from "@gtmhub/localization";
import { OkrStatus } from "@webapp/okrs/goals/models/goal-status.models";

export type OkrModal = "closeOkr" | "reopenOkr";

const windowClass: Record<OkrModal, string> = {
  closeOkr: "medium-small close-okr",
  reopenOkr: "medium-small reopen-okr",
};

export interface IOkrStatusBindings {
  id: string;
  name: string;
  status: OkrStatus;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface OkrStatusCtrl extends IOkrStatusBindings {}
export class OkrStatusCtrl extends GtmhubController {
  tooltip: string;
  static $inject = ["$uibModal"];
  constructor(private $uibModal: IModalService) {
    super();
  }

  $onChanges(): void {
    this.tooltip = this.setTooltipText();
  }

  onStatusSelect(selectedStatus: OkrStatus, okrModal: OkrModal) {
    this.$uibModal.open({
      windowClass: windowClass[okrModal],
      component: okrModal,
      resolve: {
        goalId: () => this.id,
        goalName: () => this.name,
        selectedStatus: () => selectedStatus,
        oldStatus: () => this.status,
      },
    });
  }

  private setTooltipText(): string {
    if (this.status === "active") {
      return localize("this_okr_is_currently_in_progress");
    } else {
      return localize("work_on_this_okr_is_finished");
    }
  }
}

export const OkrStatusComponent: IComponentOptions = {
  controller: OkrStatusCtrl,
  templateUrl: require("./okr-status.jade"),
  bindings: {
    id: "<",
    name: "<",
    status: "<",
  },
};
